<template>
  <div class="solution-page">
    <!-- 1. 顶部Banner -->
    <section class="hidden md:block banner relative w-full overflow-hidden">
      <img src="@/assets/solution/Group_25.png" alt="种菇无忧，全程护航" class="w-full h-full object-cover">
      <!-- 文字遮罩 -->
      <div class="absolute inset-0 bg-black/20"></div>
      <!-- 标题内容 -->
      <div class="absolute inset-0 text-center text-white z-10 top-[20%]">
        <h1 class="text-[clamp(2.5rem,5vw,4rem)] font-bold mb-3">种菇无忧，全程护航</h1>
        <p class="text-[clamp(0.9rem,2vw,1rem)]">
          通过模拟自然生态环境，打破传统农业对气候与地域的依赖，实现菌菇生产的工业化、可控化与高效化 —— 现代农业智慧转型的核心载体。
        </p>
      </div>
    </section>
    <section class="block md:hidden relative w-full overflow-hidden h-[80vh]">
      <!-- 背景图 -->
      <img src="@/assets/product/mb_bg4.png" class="absolute inset-0 w-[100%] h-[100%]" alt="" />
      <!-- 深色遮罩提升文字可读性 -->
      <div class="absolute inset-0 bg-black/15"></div>

      <div class="relative z-10 w-full pt-[20%] px-6 flex flex-col items-center text-white">
        <img src="@/assets/logo_H.png" alt="菌丰生物" class="mb-6">
        <!-- 主标题 -->
        <h2 class="text-[24px] font-bold mb-2 text-center">种菇无忧，全程护航</h2>
        <!-- 描述文字 -->
        <p class="text-[10px] leading-6 text-center opacity-90 mb-10">
          通过模拟自然生态环境，打破传统农业对气候与地域的依赖，实现菌菇生产的工业化、可控化与高效化 —— 现代农业智慧转型的核心载体。
        </p>
      </div>
    </section>
    <!-- 2. 解决方案标题区 -->
    <section class="md:py-12 py-8 md:max-w-[56%] max-w-[94%] mx-auto px-4 text-center">
      <div class="md:hidden text-[24px] font-bold text-[#333] mb-7 text-center">
        <svg width="24" height="24" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
          <rect width="18" height="18" rx="9" fill="#41B56F" />
          <g clip-path="url(#clip0_65_495)">
            <path
              d="M9.8469 10.1032H9.43427C9.14482 10.1016 8.85537 10.1016 8.56591 10.1032H8.15329C7.10479 10.1032 6.10402 10.0831 5.38962 9.84296C4.57823 9.57044 4.18408 9.0331 4.18408 8.19861C4.18408 7.71363 4.29648 7.20246 4.50741 6.72055C4.72758 6.21863 5.04474 5.76443 5.44659 5.36875C5.87769 4.94688 6.38732 4.61432 6.96006 4.38029C7.58516 4.12779 8.2703 4 9.00009 4C9.71757 4 10.3966 4.12779 11.0186 4.38183C11.5898 4.61586 12.0994 4.94688 12.532 5.36875C12.9339 5.75982 13.2618 6.22633 13.4835 6.71901C13.7006 7.20246 13.8146 7.71517 13.8146 8.19861C13.8146 9.03156 13.4204 9.5689 12.609 9.84142C11.8962 10.0831 10.8954 10.1032 9.8469 10.1032ZM9.00009 9.76136C9.14636 9.76136 9.29263 9.76135 9.43581 9.76289H9.84844C12.0394 9.76289 13.4774 9.65358 13.4774 8.20015C13.4774 7.29946 13.0355 6.33256 12.298 5.61355C11.4512 4.79292 10.2811 4.34026 9.00009 4.34026C6.23643 4.34026 4.52434 6.34334 4.52434 8.19861C4.52434 8.8853 4.82457 9.2933 5.4974 9.51963C6.16407 9.74288 7.13404 9.76289 8.15329 9.76289H8.56591C8.70756 9.76135 8.85383 9.76135 9.00009 9.76136Z"
              fill="white" />
            <path
              d="M9.27262 14H9.23259C8.31342 13.9939 7.68217 13.7937 7.30342 13.3872C6.98163 13.0424 6.84922 12.5558 6.89541 11.8984C6.89541 11.8938 6.89695 11.8876 6.89695 11.883C6.90157 11.8522 7.02166 11.124 7.06785 10.8745C7.14483 10.4604 7.0078 9.99386 7.00627 9.98924C6.98009 9.89995 7.0309 9.80449 7.1202 9.77677C7.2095 9.7506 7.30496 9.80141 7.33267 9.89071C7.33883 9.91226 7.49433 10.4419 7.40349 10.9361C7.36038 11.1702 7.24799 11.8507 7.23567 11.9307C7.19718 12.4835 7.30188 12.8838 7.55438 13.1548C7.86693 13.4919 8.42428 13.6567 9.25569 13.6582C10.3873 13.6536 11.0355 13.0377 11.0355 11.9677V11.9662C11.0355 11.9585 11.0309 11.6705 10.7892 10.9808C10.5721 10.3572 10.6999 9.90456 10.706 9.88455C10.7322 9.79371 10.8277 9.7429 10.917 9.76908C11.0063 9.79525 11.0586 9.88917 11.0324 9.98001C11.0309 9.9877 10.9324 10.3572 11.1094 10.8684C11.3681 11.6105 11.3742 11.9261 11.3742 11.9692C11.3742 12.6128 11.1633 13.1394 10.7661 13.4935C10.4027 13.8168 9.89156 13.9908 9.28494 13.9985C9.27878 13.9985 9.2757 14 9.27262 14Z"
              fill="white" />
            <path
              d="M8.01923 13.01C7.99613 13.01 7.9715 13.0008 7.95456 12.9808C7.60044 12.5743 7.67743 11.7814 7.68205 11.7475C7.68666 11.7013 7.72823 11.6675 7.77596 11.6721C7.82215 11.6767 7.85602 11.7183 7.85141 11.766C7.85141 11.7737 7.7775 12.5204 8.08389 12.8699C8.10545 12.8946 8.11161 12.93 8.09775 12.9608C8.08235 12.9916 8.05156 13.01 8.01923 13.01ZM12.4442 6.99926C12.4026 6.99926 12.3687 6.97001 12.361 6.92997C12.2733 6.4727 11.6405 6.07085 11.6343 6.06623C11.5943 6.0416 11.582 5.98925 11.6081 5.94922C11.6328 5.90919 11.6851 5.89687 11.7252 5.92305C11.7544 5.94152 12.4272 6.36954 12.5289 6.89918C12.5335 6.92382 12.5273 6.94999 12.5104 6.97001C12.4934 6.98848 12.4688 6.99926 12.4442 6.99926Z"
              fill="white" />
          </g>
          <defs>
            <clipPath id="clip0_65_495">
              <rect width="10" height="10" fill="white" transform="translate(4 4)" />
            </clipPath>
          </defs>
        </svg>
        <div class="mt-2">解决方案</div>
      </div>
      <h2 class="md:text-[44px] text-lg font-bold text-[#41B56F] text-center mb-4">
        食用菌种植一站式解决方案
      </h2>
      <p class="text-[#666666] text-center md:text-base text-xs mx-auto md:mb-16 mb-10 leading-relaxed">
        想种菇，怕没技术?怕没销路?<br>
        我们为您提供"设备+菌种+技术+回购"全链条服务
      </p>
    </section>

    <!-- 3. 四大服务模块 -->
    <section class="md:block hidden max-w-[63%] mx-auto space-y-12 pb-16">
      <div class="flex items-center w-full group relative">
        <div class="rounded-2xl overflow-hidden shadow-sm relative line-height-0">
          <img src="@/assets/solution/Rectangle_30.png" alt="智能种植设备" class="block w-full h-auto object-cover">
          <!-- 👇 只加这一段 遮罩+文字 -->
          <div class="absolute inset-0 w-[75%] bg-[linear-gradient(89.87deg,#41b56f_30.28%,#41b56f00_99.86%)] 
            flex items-center px-12 text-white
            transition-transform duration-500 -translate-x-full group-hover:translate-x-0">
            <div>
              <div class="w-10 h-10 rounded-full border border-white flex items-center justify-center mb-3">
                <div
                  class="w-[40px] h-[40px] rounded-full border border-white border-solid flex items-center justify-center">
                  <svg t="1776846973385" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="4282" width="32" height="32">
                    <path
                      d="M423.23842 889.236714l0-266.284739 177.523159 0 0 266.284739 221.903949 0L822.665529 534.190395l133.142369 0L512 134.762263 68.191078 534.190395l133.142369 0 0 355.047342L423.23842 889.237737z"
                      p-id="4283" fill="#ffffff"></path>
                  </svg>
                </div>
              </div>
              <h3 class="text-3xl font-bold mb-3">设备</h3>
              <p class="text-white/90 w-[280px] leading-[1.8]">标准化智能仿生种植方舱，一体化集成环境调控系统，模块化成套交付，现场快速部署，无需复杂土建施工，通电即可投产开展食用菌规模化培育。</p>
            </div>
          </div>
        </div>
        <div class="flex-1 flex flex-col items-start relative">
          <span class="text-[#EDEDED] text-[48px] font-bold tracking-widest mb-4 vertical-text">
            EQUIPMENT
          </span>
          <div class="flex flex-col gap-3 absolute bottom-0 left-[-50px]">
            <div class="w-32 h-10 bg-[#41B56F] ml-auto"></div>
            <div class="w-60 h-10 bg-[#41B56F]"></div>
          </div>
        </div>
      </div>
      <!-- 模块2：菌包 -->
      <div class="flex items-center w-full group relative">
        <div class="flex-1 flex flex-col items-end relative">
          <span class="text-[#EDEDED] text-[48px] font-bold tracking-widest mb-4 vertical-text">
            Mushroom<br>Spawn
          </span>
          <div class="flex flex-col gap-3 absolute bottom-0 right-[-50px]">
            <div class="w-32 h-10 bg-[#41B56F]"></div>
            <div class="w-60 h-10 bg-[#41B56F]"></div>
          </div>
        </div>

        <div class="rounded-2xl overflow-hidden shadow-sm relative line-height-0">
          <img src="@/assets/solution/Rectangle_33.png" alt="优质菌包" class="block w-full h-auto object-cover">
          <!-- 右侧滑入绿色渐变遮罩（和你上面格式完全一样） -->
          <div class="absolute inset-0 w-[75%] right-0 ml-auto bg-[linear-gradient(270deg,#41b56f_30.28%,#41b56f00_99.86%)] 
            flex items-center justify-end px-12 text-white
            transition-transform duration-500 translate-x-full group-hover:translate-x-0">
            <div>
              <div class="w-10 h-10 rounded-full border border-white flex items-center justify-center mb-3">
                <div
                  class="w-[40px] h-[40px] rounded-full border border-white border-solid flex items-center justify-center">
                  <svg t="1776847958204" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="5980" width="32" height="32">
                    <path
                      d="M710.656 923.648c-26.624 0-53.248-11.264-80.896-35.84-27.648-23.552-54.272-57.344-84.992-96.256-37.888-49.152-81.92-103.424-137.216-153.6-56.32-50.176-116.736-86.016-169.984-117.76-52.224-31.744-97.28-58.368-124.928-91.136-59.392-68.608-11.264-139.264 30.72-186.368C306.176 59.392 568.32 53.248 768 228.352c101.376 88.064 160.768 203.776 168.96 323.584 7.168 108.544-28.672 211.968-104.448 296.96-40.96 48.128-77.824 71.68-114.688 73.728-2.048 1.024-5.12 1.024-7.168 1.024zM451.584 142.336c-103.424 0-201.728 43.008-276.48 126.976-64.512 72.704-53.248 106.496-30.72 133.12 23.552 27.648 65.536 53.248 114.688 82.944 54.272 32.768 116.736 69.632 176.128 122.88 59.392 52.224 103.424 108.544 142.336 158.72 29.696 37.888 55.296 69.632 78.848 91.136 21.504 18.432 38.912 26.624 57.344 25.6 24.576-2.048 53.248-21.504 87.04-60.416 67.584-76.8 100.352-168.96 94.208-267.264-7.168-109.568-62.464-215.04-154.624-295.936-88.064-78.848-190.464-117.76-288.768-117.76zM159.744 256z"
                      p-id="5981" fill="#ffffff"></path>
                    <path
                      d="M304.128 919.552c-35.84 0-70.656-15.36-104.448-45.056-36.864-31.744-56.32-67.584-59.392-106.496-2.048-38.912 12.288-76.8 45.056-112.64l1.024-1.024L306.176 532.48c8.192-8.192 20.48-8.192 28.672 0 8.192 8.192 8.192 20.48 0 28.672L216.064 683.008c-24.576 27.648-35.84 55.296-34.816 82.944 2.048 27.648 17.408 53.248 45.056 78.848 27.648 24.576 56.32 36.864 82.944 34.816 27.648-2.048 53.248-16.384 77.824-45.056l105.472-134.144c7.168-9.216 19.456-10.24 28.672-3.072 9.216 7.168 10.24 19.456 3.072 28.672L419.84 859.136s0 1.024-1.024 1.024c-31.744 36.864-68.608 56.32-106.496 59.392h-8.192z"
                      p-id="5982" fill="#ffffff"></path>
                    <path
                      d="M203.776 859.136c-3.072 0-5.12-1.024-7.168-3.072-52.224-52.224 16.384-122.88 72.704-179.2 9.216-9.216 18.432-18.432 25.6-26.624 4.096-4.096 10.24-4.096 14.336-1.024 4.096 4.096 4.096 10.24 1.024 14.336-8.192 8.192-16.384 17.408-26.624 26.624-60.416 61.44-107.52 114.688-72.704 150.528 4.096 4.096 4.096 10.24 0 14.336-2.048 3.072-4.096 4.096-7.168 4.096z"
                      p-id="5983" fill="#ffffff"></path>
                  </svg>
                </div>
              </div>
              <h3 class="text-3xl font-bold mb-3">菌种</h3>
              <p class="text-white/90 w-[280px] leading-[1.8]">选用经过筛选驯化的优良菌种，出菇率高、生长性状稳定，栽培周期可控，适配方舱工业化连续生产，保障稳定高产。</p>
            </div>
          </div>
        </div>
      </div>

      <!-- 模块3：技术 -->
      <div class="flex items-center w-full group relative">
        <div class="rounded-2xl overflow-hidden shadow-sm relative line-height-0">
          <img src="@/assets/solution/Rectangle_42.png" alt="专家技术指导" class="block w-full h-auto object-cover">
          <!-- 👇 只加这一段 遮罩+文字 -->
          <div class="absolute inset-0 w-[75%] bg-[linear-gradient(89.87deg,#41b56f_30.28%,#41b56f00_99.86%)] 
            flex items-center px-12 text-white
            transition-transform duration-500 -translate-x-full group-hover:translate-x-0">
            <div>
              <div class="w-10 h-10 rounded-full border border-white flex items-center justify-center mb-3">
                <div
                  class="w-[40px] h-[40px] rounded-full border border-white border-solid flex items-center justify-center">
                  <svg t="1776848628517" class="icon" viewBox="0 0 1117 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="7107" width="30" height="30">
                    <path
                      d="M1114.41 855.282c-18.535-53.164-79.881-60.788-131.165-82.209-56.32-23.468-118.738-50.743-174.9-73.541-16.02-4.33-32.079-8.64-48.109-12.977-19.13-13.042-37.85-56.339-48.081-77.87-10.203-1.425-20.387-2.868-30.618-4.31 1.592-33.327 22.416-35.096 30.627-60.547 7.205-22.491 0.735-51.666 12.176-72.425 7.95-14.429 25.87-14.531 34.844-26.885 8.127-11.236 13.49-30.803 16.03-44.58 4.655-25.135 8.667-59.532-3.379-84.444-6.954-14.336-11.329-15.713-13.265-33.093-2.327-21.067 6.293-89.796 6.637-104.644 0.875-38.558-0.074-41.677-9.476-79.239 0 0-11.47-34.025-29.417-44.246l-35.775-6.125-22.109-20.248c-89.088-54.272-184.609-16.207-235.771 4.32-73.728 23.645-120.32 95.101-87.776 247.677 5.53 26.057-14.429 37.702-13.126 51.908 2.83 31.12 3.454 105.882 33.14 124.314 2.775 1.675 23.832 6.916 23.711 5.473 2.914 30.301 5.809 60.602 8.741 90.857 7.41 20.126 25.21 22.342 30.366 50.753l-22.779 5.493c-10.203 21.531-28.951 64.819-48.11 77.86-16.03 4.339-32.05 8.658-48.08 12.978-56.162 22.798-118.608 50.083-174.9 73.541-51.256 21.42-112.621 29.045-131.193 82.218C2.653 891.392-0.754 976.71 0.158 1024h490.17l35.98-243.181-29.9-62.446 69.073-32.758 58.144 32.079-32.06 64.325L648.285 1024h468.648c0.95-47.29-2.514-132.608-2.514-168.718"
                      p-id="7108" fill="#ffffff"></path>
                  </svg>
                </div>
              </div>
              <h3 class="text-3xl font-bold mb-3">技术</h3>
              <p class="text-white/90 w-[280px] leading-[1.8]">自研食用菌方舱环境调控工艺，标准化管控培菌、出菇全流程，依托智能系统稳定模拟菌类生长微环境，保障出菇品质稳定、批次一致性强。</p>
            </div>
          </div>
        </div>
        <div class="flex-1 flex flex-col items-start relative">
          <span class="text-[#EDEDED] text-[48px] font-bold tracking-widest mb-4 vertical-text">
            EXPERT
          </span>
          <div class="flex flex-col gap-3 absolute bottom-0 left-[-50px]">
            <div class="w-32 h-10 bg-[#41B56F] ml-auto"></div>
            <div class="w-60 h-10 bg-[#41B56F]"></div>
          </div>
        </div>
      </div>

      <!-- 模块4：回购 -->
      <div class="flex items-center w-full group relative">
        <div class="flex-1 flex flex-col items-end relative">
          <span class="text-[#EDEDED] text-[48px] font-bold tracking-widest mb-4 vertical-text">
            BUYBACK
          </span>
          <div class="flex flex-col gap-3 absolute bottom-0 right-[-50px]">
            <div class="w-32 h-10 bg-[#41B56F]"></div>
            <div class="w-60 h-10 bg-[#41B56F]"></div>
          </div>
        </div>

        <div class="rounded-2xl overflow-hidden shadow-sm relative line-height-0">
          <img src="@/assets/solution/Rectangle_43.png" alt="保价回购" class="block w-full h-auto object-cover">
          <!-- 右侧滑入绿色渐变遮罩（和你上面格式完全一样） -->
          <div class="absolute inset-0 w-[75%] right-0 ml-auto bg-[linear-gradient(270deg,#41b56f_30.28%,#41b56f00_99.86%)] 
            flex items-center justify-end px-12 text-white
            transition-transform duration-500 translate-x-full group-hover:translate-x-0">
            <div>
              <div class="w-10 h-10 rounded-full border border-white flex items-center justify-center mb-3">
                <div
                  class="w-[40px] h-[40px] rounded-full border border-white border-solid flex items-center justify-center">
                  <svg t="1776848845190" class="icon" viewBox="0 0 1024 1024" version="1.1"
                    xmlns="http://www.w3.org/2000/svg" p-id="8233" width="24" height="24">
                    <path
                      d="M520.194688 741.37853c-98.820111 0-177.096973-0.404793-186.812007-1.657122-32.573193-4.187078-47.499938-32.623792-51.181026-48.764916l-0.101198-0.468042L150.024064 48.069179l0.366844-2.871501A12.131143 12.131143 0 0 0 148.885584 44.274243H45.663348a22.137122 22.137122 0 0 1 0-44.274243h110.230216l2.808252 0.746337a57.252922 57.252922 0 0 1 18.177739 8.981347c11.941396 8.930747 18.304237 21.871476 17.861495 36.001284l130.621668 635.310093c0.505991 1.808919 4.161779 13.547918 13.687066 14.774948 21.782928 2.289611 388.348363 1.15113 629.427943-0.177097h0.126498a22.137122 22.137122 0 0 1 0.113848 44.274243c-39.606473 0.215046-275.461692 1.467375-448.523385 1.467375zM150.492106 44.274243z"
                      p-id="8234" fill="#ffffff"></path>
                    <path
                      d="M286.426683 600.864731a22.137122 22.137122 0 0 1-3.301593-44.021247l585.68499-89.193626 80.439976-293.474985H198.725732a22.137122 22.137122 0 1 1 0-44.274243h779.606177a22.137122 22.137122 0 0 1 21.352835 27.993972L907.746115 493.227721a22.137122 22.137122 0 0 1-18.013292 16.027276l-599.941297 91.369388a22.352168 22.352168 0 0 1-3.364843 0.240346zM442.942458 1024a118.047783 118.047783 0 1 1 118.047783-118.047783 118.17428 118.17428 0 0 1-118.047783 118.047783z m0-191.808672a73.773539 73.773539 0 1 0 73.77354 73.773539 73.849438 73.849438 0 0 0-73.77354-73.773539zM842.47323 1024a118.047783 118.047783 0 1 1 118.047783-118.047783 118.17428 118.17428 0 0 1-118.047783 118.047783z m0-191.808672a73.773539 73.773539 0 1 0 73.77354 73.773539 73.849438 73.849438 0 0 0-73.77354-73.773539z"
                      p-id="8235" fill="#ffffff"></path>
                  </svg>
                </div>
              </div>
              <h3 class="text-3xl font-bold mb-3">包销</h3>
              <p class="text-white/90 w-[280px] leading-[1.8]">构建稳定多元销售渠道，对接生鲜商超、农贸批发市场、预制菜加工企业，实现产出产品规模化持续外销，保障项目收益稳定。</p>
            </div>
          </div>
        </div>
      </div>
    </section>
    <solution class="max-w-[94%] block md:hidden">
      <div class="flex gap-4 px-4 w-full overflow-x-auto pb-8 no-scrollbar scroll-touch">

        <div class="relative w-[46%] max-w-[320px] aspect-[3/5] rounded-2xl overflow-hidden shrink-0">
          <img src="@/assets/solution/Rectangle_30.png" alt="智能种植设备" class="block w-full h-full object-cover">
          <div class="absolute inset-0 bg-black/20"></div>
          <div class="absolute top-[35%] left-0 right-0 p-3 text-white">
            <div
              class="w-[30px] h-[30px] rounded-full border border-white border-solid flex items-center justify-center">
              <svg t="1776846973385" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="4282" width="24" height="24">
                <path
                  d="M423.23842 889.236714l0-266.284739 177.523159 0 0 266.284739 221.903949 0L822.665529 534.190395l133.142369 0L512 134.762263 68.191078 534.190395l133.142369 0 0 355.047342L423.23842 889.237737z"
                  p-id="4283" fill="#ffffff"></path>
              </svg>
            </div>
            <h3 class="text-[18px] mb-1">设备</h3>
            <p class="text-[10px] leading-[1.5] text-white/90">
              标准化智能仿生种植方舱，一体化集成环境调控系统，模块化成套交付，现场快速部署，无需复杂土建施工，通电即可投产开展食用菌规模化培育。
            </p>
          </div>
        </div>

        <div class="relative w-[46%] max-w-[320px] aspect-[3/5] rounded-2xl overflow-hidden shrink-0">
          <img src="@/assets/solution/Rectangle_33.png" alt="智能种植设备" class="block w-full h-full object-cover">

          <div class="absolute inset-0 bg-black/20"></div>
          <div class="absolute top-[35%] left-0 right-0 p-3 text-white">
            <div
              class="w-[30px] h-[30px] rounded-full border border-white border-solid flex items-center justify-center">
              <svg t="1776847958204" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="5980" width="24" height="24">
                <path
                  d="M710.656 923.648c-26.624 0-53.248-11.264-80.896-35.84-27.648-23.552-54.272-57.344-84.992-96.256-37.888-49.152-81.92-103.424-137.216-153.6-56.32-50.176-116.736-86.016-169.984-117.76-52.224-31.744-97.28-58.368-124.928-91.136-59.392-68.608-11.264-139.264 30.72-186.368C306.176 59.392 568.32 53.248 768 228.352c101.376 88.064 160.768 203.776 168.96 323.584 7.168 108.544-28.672 211.968-104.448 296.96-40.96 48.128-77.824 71.68-114.688 73.728-2.048 1.024-5.12 1.024-7.168 1.024zM451.584 142.336c-103.424 0-201.728 43.008-276.48 126.976-64.512 72.704-53.248 106.496-30.72 133.12 23.552 27.648 65.536 53.248 114.688 82.944 54.272 32.768 116.736 69.632 176.128 122.88 59.392 52.224 103.424 108.544 142.336 158.72 29.696 37.888 55.296 69.632 78.848 91.136 21.504 18.432 38.912 26.624 57.344 25.6 24.576-2.048 53.248-21.504 87.04-60.416 67.584-76.8 100.352-168.96 94.208-267.264-7.168-109.568-62.464-215.04-154.624-295.936-88.064-78.848-190.464-117.76-288.768-117.76zM159.744 256z"
                  p-id="5981" fill="#ffffff"></path>
                <path
                  d="M304.128 919.552c-35.84 0-70.656-15.36-104.448-45.056-36.864-31.744-56.32-67.584-59.392-106.496-2.048-38.912 12.288-76.8 45.056-112.64l1.024-1.024L306.176 532.48c8.192-8.192 20.48-8.192 28.672 0 8.192 8.192 8.192 20.48 0 28.672L216.064 683.008c-24.576 27.648-35.84 55.296-34.816 82.944 2.048 27.648 17.408 53.248 45.056 78.848 27.648 24.576 56.32 36.864 82.944 34.816 27.648-2.048 53.248-16.384 77.824-45.056l105.472-134.144c7.168-9.216 19.456-10.24 28.672-3.072 9.216 7.168 10.24 19.456 3.072 28.672L419.84 859.136s0 1.024-1.024 1.024c-31.744 36.864-68.608 56.32-106.496 59.392h-8.192z"
                  p-id="5982" fill="#ffffff"></path>
                <path
                  d="M203.776 859.136c-3.072 0-5.12-1.024-7.168-3.072-52.224-52.224 16.384-122.88 72.704-179.2 9.216-9.216 18.432-18.432 25.6-26.624 4.096-4.096 10.24-4.096 14.336-1.024 4.096 4.096 4.096 10.24 1.024 14.336-8.192 8.192-16.384 17.408-26.624 26.624-60.416 61.44-107.52 114.688-72.704 150.528 4.096 4.096 4.096 10.24 0 14.336-2.048 3.072-4.096 4.096-7.168 4.096z"
                  p-id="5983" fill="#ffffff"></path>
              </svg>
            </div>
            <h3 class="text-[18px] mb-1">菌棒</h3>
            <p class="text-[10px] leading-[1.5] text-white/90">
              选用经过筛选驯化的优良菌种，出菇率高、生长性状稳定，栽培周期可控，适配方舱工业化连续生产，保障稳定高产。
            </p>
          </div>
        </div>

        <div class="relative w-[46%] max-w-[320px] aspect-[3/5] rounded-2xl overflow-hidden shrink-0">
          <img src="@/assets/solution/Rectangle_42.png" alt="智能种植设备" class="block w-full h-full object-cover">
          <div class="absolute inset-0 bg-black/20"></div>
          <div class="absolute top-[35%] left-0 right-0 p-3 text-white">
            <div
              class="w-[30px] h-[30px] rounded-full border border-white border-solid flex items-center justify-center">
              <svg t="1776848628517" class="icon" viewBox="0 0 1117 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="7107" width="20" height="20">
                <path
                  d="M1114.41 855.282c-18.535-53.164-79.881-60.788-131.165-82.209-56.32-23.468-118.738-50.743-174.9-73.541-16.02-4.33-32.079-8.64-48.109-12.977-19.13-13.042-37.85-56.339-48.081-77.87-10.203-1.425-20.387-2.868-30.618-4.31 1.592-33.327 22.416-35.096 30.627-60.547 7.205-22.491 0.735-51.666 12.176-72.425 7.95-14.429 25.87-14.531 34.844-26.885 8.127-11.236 13.49-30.803 16.03-44.58 4.655-25.135 8.667-59.532-3.379-84.444-6.954-14.336-11.329-15.713-13.265-33.093-2.327-21.067 6.293-89.796 6.637-104.644 0.875-38.558-0.074-41.677-9.476-79.239 0 0-11.47-34.025-29.417-44.246l-35.775-6.125-22.109-20.248c-89.088-54.272-184.609-16.207-235.771 4.32-73.728 23.645-120.32 95.101-87.776 247.677 5.53 26.057-14.429 37.702-13.126 51.908 2.83 31.12 3.454 105.882 33.14 124.314 2.775 1.675 23.832 6.916 23.711 5.473 2.914 30.301 5.809 60.602 8.741 90.857 7.41 20.126 25.21 22.342 30.366 50.753l-22.779 5.493c-10.203 21.531-28.951 64.819-48.11 77.86-16.03 4.339-32.05 8.658-48.08 12.978-56.162 22.798-118.608 50.083-174.9 73.541-51.256 21.42-112.621 29.045-131.193 82.218C2.653 891.392-0.754 976.71 0.158 1024h490.17l35.98-243.181-29.9-62.446 69.073-32.758 58.144 32.079-32.06 64.325L648.285 1024h468.648c0.95-47.29-2.514-132.608-2.514-168.718"
                  p-id="7108" fill="#ffffff"></path>
              </svg>
            </div>
            <h3 class="text-[18px] mb-1">技术</h3>
            <p class="text-[10px] leading-[1.5] text-white/90">
              自研食用菌方舱环境调控工艺，标准化管控培菌、出菇全流程，依托智能系统稳定模拟菌类生长微环境，保障出菇品质稳定、批次一致性强。
            </p>
          </div>
        </div>

        <div class="relative w-[46%] max-w-[320px] aspect-[3/5] rounded-2xl overflow-hidden shrink-0">
          <img src="@/assets/solution/Rectangle_43.png" alt="智能种植设备" class="block w-full h-full object-cover">
          <div class="absolute inset-0 bg-black/20"></div>
          <div class="absolute top-[35%] left-0 right-0 p-3 text-white">
            <div
              class="w-[30px] h-[30px] rounded-full border border-white border-solid flex items-center justify-center">
              <svg t="1776848845190" class="icon" viewBox="0 0 1024 1024" version="1.1"
                xmlns="http://www.w3.org/2000/svg" p-id="8233" width="20" height="20">
                <path
                  d="M520.194688 741.37853c-98.820111 0-177.096973-0.404793-186.812007-1.657122-32.573193-4.187078-47.499938-32.623792-51.181026-48.764916l-0.101198-0.468042L150.024064 48.069179l0.366844-2.871501A12.131143 12.131143 0 0 0 148.885584 44.274243H45.663348a22.137122 22.137122 0 0 1 0-44.274243h110.230216l2.808252 0.746337a57.252922 57.252922 0 0 1 18.177739 8.981347c11.941396 8.930747 18.304237 21.871476 17.861495 36.001284l130.621668 635.310093c0.505991 1.808919 4.161779 13.547918 13.687066 14.774948 21.782928 2.289611 388.348363 1.15113 629.427943-0.177097h0.126498a22.137122 22.137122 0 0 1 0.113848 44.274243c-39.606473 0.215046-275.461692 1.467375-448.523385 1.467375zM150.492106 44.274243z"
                  p-id="8234" fill="#ffffff"></path>
                <path
                  d="M286.426683 600.864731a22.137122 22.137122 0 0 1-3.301593-44.021247l585.68499-89.193626 80.439976-293.474985H198.725732a22.137122 22.137122 0 1 1 0-44.274243h779.606177a22.137122 22.137122 0 0 1 21.352835 27.993972L907.746115 493.227721a22.137122 22.137122 0 0 1-18.013292 16.027276l-599.941297 91.369388a22.352168 22.352168 0 0 1-3.364843 0.240346zM442.942458 1024a118.047783 118.047783 0 1 1 118.047783-118.047783 118.17428 118.17428 0 0 1-118.047783 118.047783z m0-191.808672a73.773539 73.773539 0 1 0 73.77354 73.773539 73.849438 73.849438 0 0 0-73.77354-73.773539zM842.47323 1024a118.047783 118.047783 0 1 1 118.047783-118.047783 118.17428 118.17428 0 0 1-118.047783 118.047783z m0-191.808672a73.773539 73.773539 0 1 0 73.77354 73.773539 73.849438 73.849438 0 0 0-73.77354-73.773539z"
                  p-id="8235" fill="#ffffff"></path>
              </svg>
            </div>
            <h3 class="text-[18px] mb-1">包销</h3>
            <p class="text-[10px] leading-[1.5] text-white/90">
              构建稳定多元销售渠道，对接生鲜商超、农贸批发市场、预制菜加工企业，实现产出产品规模化持续外销，保障项目收益稳定。
            </p>
          </div>
        </div>
      </div>
    </solution>


    <!-- 4. 服务亮点 -->
    <section class="md:max-w-[63%] max-w-[94%] mx-auto px-4 md:pb-12">
      <div class="w-full h-[1px] bg-[#7BB850]"></div>
      <div class="md:py-4 py-2 overflow-hidden" ref="marqueeWrap">
        <!-- 滚动内容：第一份 -->
        <div class="flex whitespace-nowrap w-max" ref="marqueeInner">
          <div class="flex items-center gap-2 px-4 shrink-0">
            <div class="w-2 h-2 bg-[#7BB850] rounded-full"></div>
            <span class="text-[#7BB850] md:text-sm text-xs">制冷、制热、加湿、通风及 CO₂ 调控高度整合，单仓全能环境管理。</span>
          </div>
          <div class="flex items-center gap-2 px-4 shrink-0">
            <div class="w-2 h-2 bg-[#7BB850] rounded-full"></div>
            <span class="text-[#7BB850] md:text-sm text-xs">自适应生长算法，按品种与生长阶段毫秒级自动调节温湿光气。</span>
          </div>
          <div class="flex items-center gap-2 px-4 shrink-0">
            <div class="w-2 h-2 bg-[#7BB850] rounded-full"></div>
            <span class="text-[#7BB850] md:text-sm text-xs">模块化设计，快速组装与异地复制，从试验田到千亩级扩张。</span>
          </div>
          <div class="flex items-center gap-2 px-4 shrink-0">
            <div class="w-2 h-2 bg-[#7BB850] rounded-full"></div>
            <span class="text-[#7BB850] md:text-sm text-xs">核心元器件工业级标准，电源与控制双重冗余，全年不间断运行。</span>
          </div>
        </div>
        <!-- 第二份：与第一份完全相同的副本（无缝关键） -->
        <!-- <div class="flex whitespace-nowrap w-max">
          <div class="flex items-center gap-2 px-4 shrink-0">
            <div class="w-2 h-2 bg-[#7BB850] rounded-full"></div>
            <span class="text-[#7BB850] md:text-sm text-xs">制冷、制热、加湿、通风及 CO₂ 调控高度整合，单仓全能环境管理。</span>
          </div>
          <div class="flex items-center gap-2 px-4 shrink-0">
            <div class="w-2 h-2 bg-[#7BB850] rounded-full"></div>
            <span class="text-[#7BB850] md:text-sm text-xs">自适应生长算法，按品种与生长阶段毫秒级自动调节温湿光气。</span>
          </div>
          <div class="flex items-center gap-2 px-4 shrink-0">
            <div class="w-2 h-2 bg-[#7BB850] rounded-full"></div>
            <span class="text-[#7BB850] md:text-sm text-xs">模块化设计，快速组装与异地复制，从试验田到千亩级扩张。</span>
          </div>
          <div class="flex items-center gap-2 px-4 shrink-0">
            <div class="w-2 h-2 bg-[#7BB850] rounded-full"></div>
            <span class="text-[#7BB850] md:text-sm text-xs">核心元器件工业级标准，电源与控制双重冗余，全年不间断运行。</span>
          </div>
        </div> -->
      </div>
      <div class="w-full h-[1px] bg-[#7BB850]"></div>
    </section>

    <!-- 5. 底部CTA区 -->
    <section class="w-full md:py-16 py-10 relative overflow-hidden">
      <img src="@/assets/solution/Group_22.png" alt="" class="w-full md:h-auto h-[150px] object-cover">

      <div class="absolute z-10 text-center text-white md:top-48 top-[40%] w-full text-center">
        <h2 class="md:text-5xl text-xl font-bold">您只需投入，我们负责到底！</h2>
      </div>
    </section>
  </div>
</template>

<script>
export default {
  name: "SolutionPage",
  data() {
    return {
      isPause: false, // 控制动画暂停,
      rafId: null
    };
  },
  mounted() {
    this.startMarquee()
  },
  destroyed() {
    if (this.rafId) cancelAnimationFrame(this.rafId)
  },
  methods: {
    startMarquee() {
      const wrap = this.$refs.marqueeWrap
      const inner = this.$refs.marqueeInner
      if (!wrap || !inner) return
      const speed = 1.2 // 每帧移动像素，越大越快，可调
      const halfWidth = () => inner.scrollWidth / 2 // 一份内容的宽度

      const move = () => {
        if (!this.isPause) {
          wrap.scrollLeft += speed
          // 滚到一份内容的结尾时，减掉一份宽度 → 视觉无缝回到开头
          if (wrap.scrollLeft >= halfWidth()) {
            wrap.scrollLeft -= halfWidth()
          }
        }
        this.rafId = requestAnimationFrame(move)
      }
      this.rafId = requestAnimationFrame(move)
    }
  }
}
</script>

<style scoped>
/* 垂直文字样式 */
.vertical-text {
  writing-mode: vertical-rl;
  text-orientation: mixed;
}

@keyframes marquee {
  from {
    transform: translateX(0);
  }

  to {
    transform: translateX(calc(-100% / 4));
  }

  /* 4组就除以4 */
}

.animate-marquee {
  animation: marquee 5s linear infinite;
}

.no-scrollbar::-webkit-scrollbar {
  display: none;
}

.no-scrollbar {
  -ms-overflow-style: none;
  scrollbar-width: none;
}
</style>